import { useTranslation } from 'react-i18next';
import { mockPayments } from '@/mocks/dashboard';
import DashboardPayments from './components/DashboardPayments';

export default function PaymentsPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.payments.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Payment history and pending invoices</p>
      </div>
      <DashboardPayments payments={mockPayments} />
    </div>
  );
}